if (!customElements.get('results-mobile-facets')) {
  customElements.define(
    'results-mobile-facets',
    class ResultsMobileFacets extends window.BAO.CustomElement() {
      constructor () {
        super()
        this.eventBus = window.theme.results.eventBus
        this.sortOptions = window.theme.results.stateLayer.state.sort
        this.lastFacets = null

        this.handleFormChangeBound = this.handleFormChange.bind(this)
        this.handleSortClickBound = this.handleSortClick.bind(this)
        this.handlePriceInputBound = this.handlePriceInput.bind(this)
        this.handleResetBound = this.handleReset.bind(this)
        this.handleCloseFacetAccordionsBound =
          this.handleCloseFacetAccordions.bind(this)
      }

      connectedCallback () {
        super.connectedCallback()

        this.elements = {
          list: this.querySelector('[data-results-mobile-facets-el="list"]'),
          form: this.querySelector('[data-results-mobile-facets-el="form"]'),
          activeFilters: this.querySelector(
            '[data-results-mobile-facets-el="activeFilters"]',
          ),
          activeList: this.querySelector(
            '[data-results-mobile-facets-el="activeList"]',
          ),
        }

        const EVENTS = window.theme.results.events

        this.onFacetsUpdated = ({ facets, activeFacets }) => {
          this.lastFacets = facets
          this.renderFacets(facets)
          this.renderActiveFacets(activeFacets)
          this.schedulePriceSliderLayoutSync()
        }
        this.onActiveFacetsUpdated = ({ activeFacets }) => {
          this.renderActiveFacets(activeFacets)
          this.schedulePriceSliderLayoutSync()
        }

        this.eventBus.subscribe(
          EVENTS.STATE.FACETS_UPDATED,
          this.onFacetsUpdated,
        )
        this.eventBus.subscribe(
          EVENTS.STATE.ACTIVE_FACETS_UPDATED,
          this.onActiveFacetsUpdated,
        )
      }

      disconnectedCallback () {
        if (this._sliderLayoutOuterRaf != null) {
          cancelAnimationFrame(this._sliderLayoutOuterRaf)
          this._sliderLayoutOuterRaf = null
        }
        const EVENTS = window.theme.results.events
        this.eventBus.unsubscribe(
          EVENTS.STATE.FACETS_UPDATED,
          this.onFacetsUpdated,
        )
        this.eventBus.unsubscribe(
          EVENTS.STATE.ACTIVE_FACETS_UPDATED,
          this.onActiveFacetsUpdated,
        )
      }

      schedulePriceSliderLayoutSync () {
        if (this._sliderLayoutOuterRaf != null) {
          cancelAnimationFrame(this._sliderLayoutOuterRaf)
        }
        this._sliderLayoutOuterRaf = requestAnimationFrame(() => {
          this._sliderLayoutOuterRaf = null
          requestAnimationFrame(() => {
            if (!this.isConnected) return
            this.elements.list.querySelectorAll('range-slider').forEach(
              slider => {
                if (typeof slider.syncVisualFromValues === 'function') {
                  slider.syncVisualFromValues()
                }
              },
            )
          })
        })
      }

      setupEventListeners () {
        if (!this.formChangeBound) {
          this.elements.form.addEventListener(
            'change',
            this.handleFormChangeBound,
          )
          this.formChangeBound = true
        }

        if (!this.listListenersBound) {
          this.elements.list.addEventListener(
            'click',
            this.handleSortClickBound,
          )
          this.elements.list.addEventListener(
            'input',
            this.handlePriceInputBound,
          )
          this.listListenersBound = true
        }

        if (!this.resetListenerBound) {
          const reset = document.querySelector(
            '[data-results-mobile-facets-external-element="reset"]',
          )

          if (reset) {
            reset.addEventListener('click', this.handleResetBound)
            this.resetListenerBound = true
          }
        }

        if (!this.drawerClosedBound) {
          window.BAO.eventBus.addEventListener(
            window.BAO.EVENTS.DRAWER.CLOSED,
            this.handleCloseFacetAccordionsBound,
          )
          this.drawerClosedBound = true
        }
      }

      handleCloseFacetAccordions (event) {
        this.querySelectorAll('details[open]').forEach(detail => {
          detail.removeAttribute('open')
        })
      }

      handleSortClick (event) {
        const button = event.target.closest('.clc-Sort_Facet')
        if (!button || !this.elements.list.contains(button)) return

        const value = button.getAttribute('data-sort-value')
        if (!value) return

        const [field, order] = value.split('~')
        this.eventBus.publish(window.theme.results.events.UI.SORT_CHANGED, {
          field,
          order,
        })
      }

      handleReset () {
        this.eventBus.publish(window.theme.results.events.UI.FACET_CLEAR_ALL)
      }

      handleFormChange (event) {
        const target = event.target
        if (target.type === 'number') return

        const value = [target.value]
        const field = target.getAttribute('data-facet-field')
        const UI = window.theme.results.events.UI

        if (target.checked === true) {
          this.eventBus.publish(UI.FACET_ADDED, { field, value })
        } else {
          this.eventBus.publish(UI.FACET_REMOVED, { field, value })
        }
      }

      handlePriceInput (event) {
        const target = event.target
        if (!target.matches('[data-facet-field="price"]')) return

        clearTimeout(this.priceDebounce)
        this.priceDebounce = setTimeout(() => {
          const priceRange = this.elements.list.querySelector(
            '[data-facet-price]',
          )
          if (!priceRange) return

          const minEl = priceRange.querySelector('[data-price-range-el="min"]')
          const maxEl = priceRange.querySelector('[data-price-range-el="max"]')

          this.eventBus.publish(window.theme.results.events.UI.PRICE_CHANGED, {
            min: minEl ? minEl.value : '',
            max: maxEl ? maxEl.value : '',
          })
        }, 400)
      }

      renderFacets (facets) {
        const openFields = new Set()
        let sortOpen = false
        let priceOpen = false
        this.elements.list.querySelectorAll('details[open]').forEach(detail => {
          if (detail.hasAttribute('data-sort-accordion')) {
            sortOpen = true
            return
          }
          if (detail.hasAttribute('data-price-accordion')) {
            priceOpen = true
            return
          }
          const input = detail.querySelector('[data-facet-field]')
          if (input) openFields.add(input.getAttribute('data-facet-field'))
        })

        this.elements.list.innerHTML = ''

        facets.forEach(facet => {
          this.elements.list.insertAdjacentHTML(
            'beforeend',
            window.theme.results.templates.AccordionFacets(facet),
          )
        })

        this.elements.list.insertAdjacentHTML(
          'beforeend',
          window.theme.results.templates.SortAccordion(this.sortOptions),
        )

        openFields.forEach(field => {
          const input = this.elements.list.querySelector(
            `[data-facet-field="${field}"]`,
          )
          if (input) {
            const details = input.closest('details')
            if (details) details.setAttribute('open', '')
          }
        })

        if (sortOpen) {
          const sortDetails = this.elements.list.querySelector(
            'details[data-sort-accordion]',
          )
          if (sortDetails) sortDetails.setAttribute('open', '')
        }

        if (priceOpen) {
          const priceDetails = this.elements.list.querySelector(
            'details[data-price-accordion]',
          )
          if (priceDetails) priceDetails.setAttribute('open', '')
        }

        this.setupEventListeners()
      }

      renderActiveFacets (facets) {
        this.elements.activeFilters.toggleAttribute(
          'hidden',
          facets.length === 0,
        )
        this.elements.activeList.innerHTML = ''

        facets.forEach(facet => {
          this.elements.activeList.insertAdjacentHTML(
            'beforeend',
            window.theme.results.templates.ActiveFacet(facet),
          )
        })
      }
    },
  )
}
